import React from "react";
import CmsManager from "../CMS/CmsManager";

function PropertiesList() {
  return (
    <CmsManager
      title="Properties"
      resource="projects"
      fields={[
        { name: "title", label: "Property Heading", fullWidth: false },
        { name: "slug", label: "URL Slug", fullWidth: false },
        { name: "property_id", label: "Property ID", fullWidth: false },
        { name: "location", label: "Location", fullWidth: false },
        { name: "property_type", label: "Property Type", fullWidth: false },
        { name: "status", label: "Status", fullWidth: false },
        { name: "label", label: "Label", fullWidth: false },
        { name: "size", label: "Size", fullWidth: false },
        { name: "price", label: "Price", fullWidth: false },
        { name: "floors", label: "Floors", fullWidth: false },
        { name: "distance_from_metro", label: "Distance From Metro", fullWidth: false },
        { name: "description", label: "Property Description", type: "richtext" },
        { name: "featuredImage", label: "Featured Image", type: "image", fullWidth: false },
        { name: "altText", label: "Featured Image Alt Tag", fullWidth: false },
        { name: "image1", label: "Gallery Image 2", type: "image", fullWidth: false, showInGrid: false },
        { name: "image1Alt", label: "Gallery Image 2 Alt Tag", fullWidth: false, showInGrid: false },
        { name: "image2", label: "Gallery Image 3", type: "image", fullWidth: false, showInGrid: false },
        { name: "image2Alt", label: "Gallery Image 3 Alt Tag", fullWidth: false, showInGrid: false },
        { name: "image3", label: "Gallery Image 4", type: "image", fullWidth: false, showInGrid: false },
        { name: "image3Alt", label: "Gallery Image 4 Alt Tag", fullWidth: false, showInGrid: false },
        { name: "image4", label: "Gallery Image 5", type: "image", fullWidth: false, showInGrid: false },
        { name: "image4Alt", label: "Gallery Image 5 Alt Tag", fullWidth: false, showInGrid: false },
        { name: "metaTitle", label: "Title Tag", fullWidth: false, showInGrid: false },
        { name: "metaDescription", label: "Meta Description", type: "textarea", rows: 3, showInGrid: false },
        { name: "metaKeywords", label: "Meta Keywords", type: "keywords", rows: 2, showInGrid: false },
      ]}
    />
  );
}

export default PropertiesList;
